export const CASHOUT_TYPES = [
    { label: 'Instant', name: 'instant', value: 'instant' },
    { label: 'Pending', name: 'pending', value: 'pending' },
]